<template>
  <v-dialog v-model="dialog" width="1200px">
    <v-card>
      <v-card-title class="mx-3 pb-0">
        {{ $t("SupplierScoreLog.title") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="suppliers"
        :loading="loading"
        :search="filter"
        multi-sort
        disable-pagination
        hide-default-footer
        class="elevation-0 px-6"
        fixed-header
        height="360px"
        v-resize="resizeHeader"
      >
        <template v-slot:item.created="{ item }">
          {{item.created | formatTime}}
        </template>
      </v-data-table>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Suppliers from "@/api/suppliers";

export default {
  name: "DialogSupplierScoreLog",

  components: {
  },

  props: {
    value: Boolean,
    data: Object,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("SupplierScoreLog.Fields.supplier_code"),
          align: "start",
          sortable: false,
          value: "supplier.supplier_code",
        },
        {
          text: i18n.t("SupplierScoreLog.Fields.supplier_name"),
          align: "start",
          sortable: false,
          value: "supplier.supplier_name",
        },
        {
          text: i18n.t("SupplierScoreLog.Fields.before_score"),
          align: "center",
          sortable: false,
          value: "before_score",
        },
        {
          text: i18n.t("SupplierScoreLog.Fields.after_score"),
          align: "center",
          sortable: false,
          value: "after_score",
        },
        {
          text: i18n.t("SupplierScoreLog.Fields.created"),
          align: "center",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("SupplierScoreLog.Fields.creater"),
          align: "center",
          sortable: false,
          value: "creater.name",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    filter: "",
    suppliers: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 每次打开对话框重置查询
          this.getSuppliersFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.suppliers = [];
          this.filter = "";
        }
      },
    },

  },

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    getSuppliersFromAPI() {
      if (this.data) {
        Suppliers.getSupplierScoreLogs({supplier_ids:[this.data.id]}).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.suppliers = response.data.supplier_score_logs
            }
          }.bind(this)
        );
      }
    },
  },
};
</script>
